// https://github.com/selfthinker/dokuwiki_template_writr/blob/master/js/skip-link-focus-fix.js
(function($) {
  jQuery.extend(jQuery.expr[':'], {
    focusable: function(el, index, selector){
      var $element = $(el);
      return $element.is(':input:enabled, a[href], area[href], object, [tabindex]') && !$element.is(':hidden');
    }
  });
  function focusOnElement($element) {
    if (!$element.length) {
      return;
    }
    if (!$element.is(':focusable')) {
      // add tabindex to make focusable and remove again
      $element.attr('tabindex', -1).on('blur focusout', function () {
        $(this).removeAttr('tabindex');
      });
    }
    $element.focus();
  }
  function onDOMContentLoaded() {
    // if there is a '#' in the URL (someone linking directly to a page with an anchor)
    if (document.location.hash) {
      focusOnElement($(document.location.hash));
    }
    // if the hash has been changed (activation of an in-page link)
    $(window).bind('hashchange', function() {
      var hash = "#"+window.location.hash.replace(/^#/,'');
      focusOnElement($(hash));
    });

    // find target for skip-to-content link
    var target
    var pageContent = $('.page-content__primary')
    var pageContent2 = $('.page-content')
    var breadCrumb = $('.breadcrumbs')
    var hero2 = $('.hero')
    if (pageContent.length > 0) {
      target = pageContent
    } else if (pageContent2.length > 0) {
      target = pageContent2
    } else if (breadCrumb.length > 0) {
      target = breadCrumb.next()
    } else if (hero2.length > 0) {
      target = hero2
    } else {
      target = $('.free-content').first()
    }

    if (!target.attr('id')) {
      target.attr('id', 'skip-target')
    }
    $('a.skip-to-content').attr('href', '#' + target.attr('id'))
  };
  if (document.readyState == 'loading') {
    document.addEventListener("DOMContentLoaded", onDOMContentLoaded);
  } else {
    onDOMContentLoaded();
  }
})(jQuery);